// Mock data for Florent Bajraktari's portfolio

export const personalInfo = {
  name: "Florent Bajraktari",
  role: "Python Developer",
  specialization: "Desktop & Backend Development",
  location: "Switzerland",
  email: "info@florentdev.online",
  linkedin: "https://linkedin.com/in/florent-bajraktari",
  headline: "Building Smart Business Applications with Python",
  subheadline: "Helping companies simplify operations through custom software solutions",
  bio: "I'm a Python developer based in Switzerland, specializing in building practical business applications for small and medium-sized companies. With expertise in both desktop and backend development, I create custom software solutions that streamline operations and solve real business problems. My approach combines clean code, modern frameworks, and a deep understanding of business needs to deliver applications that truly make a difference."
};

export const skills = [
  { name: "Python", level: 95 },
  { name: "FastAPI", level: 90 },
  { name: "Flask", level: 85 },
  { name: "PostgreSQL", level: 80 },
  { name: "Kivy (Desktop UI)", level: 75 },
  { name: "REST APIs", level: 90 },
  { name: "MongoDB", level: 75 },
  { name: "Git & Version Control", level: 85 }
];

export const projects = [
  {
    id: 1,
    title: "EmployeeHub",
    description: "A modern employee management and workforce platform for companies. Includes employee records, dashboards, timesheets, work tracking, and admin tools.",
    techStack: ["Python", "FastAPI", "Flask", "PostgreSQL"],
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&q=80",
    demoLink: null
  },
  {
    id: 2,
    title: "EmployeeHub Mini",
    description: "A simplified and client-focused version of EmployeeHub built for small companies. Includes work hours, attendance, employee access, admin control, and lightweight management tools.",
    techStack: ["Python", "Flask", "PostgreSQL", "Responsive UI"],
    image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=800&q=80",
    demoLink: null
  },
  {
    id: 3,
    title: "KosovAI",
    description: "An AI-powered Albanian-focused chatbot and knowledge platform with conversation handling, smart responses, and modern user experience.",
    techStack: ["Python", "FastAPI", "AI Integration", "PostgreSQL"],
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&q=80",
    demoLink: null
  },
  {
    id: 4,
    title: "Restaurant Point App",
    description: "Point-of-sale system for restaurants with order management, inventory tracking, and sales analytics. Streamlines daily operations and reduces errors.",
    techStack: ["Python", "FastAPI", "PostgreSQL", "React"],
    image: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800&q=80",
    demoLink: null
  },
  {
    id: 5,
    title: "Vehicle Shop App",
    description: "Inventory management system for auto dealerships featuring vehicle tracking, customer management, and sales pipeline automation.",
    techStack: ["Python", "Flask", "MongoDB", "JavaScript"],
    image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=800&q=80",
    demoLink: null
  },
  {
    id: 6,
    title: "Banking App",
    description: "Secure financial management application with transaction tracking, account management, and automated reporting features for small financial institutions.",
    techStack: ["Python", "FastAPI", "PostgreSQL", "JWT Auth"],
    image: "https://images.unsplash.com/photo-1501167786227-4cba60f6d58f?w=800&q=80",
    demoLink: null
  }
];

export const services = [
  {
    id: 1,
    title: "Custom Business Apps",
    description: "Tailored software solutions designed specifically for your business needs. From concept to deployment, I build applications that solve your unique challenges.",
    icon: "code"
  },
  {
    id: 2,
    title: "Internal Tools for Companies",
    description: "Streamline your internal processes with custom-built tools. Automate workflows, manage data efficiently, and improve team productivity.",
    icon: "wrench"
  },
  {
    id: 3,
    title: "Process Automation",
    description: "Eliminate repetitive tasks and reduce human error. I create automated solutions that save time and increase accuracy in your daily operations.",
    icon: "zap"
  },
  {
    id: 4,
    title: "Web & Desktop Solutions",
    description: "Cross-platform applications that work seamlessly on web and desktop. Deliver consistent user experiences across all devices your team uses.",
    icon: "monitor"
  }
];

export const mockContactSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      if (process.env.NODE_ENV !== 'production') {
        console.log('Mock contact form submission:', formData);
      }
      resolve({ success: true, message: 'Message sent successfully!' });
    }, 1000);
  });
};